import { CARD_API_ENDPOINT } from '@/config/consts'
import { useQuery } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { createSmartGet } from './useAuthenticatedMutation'

export interface SponsoredCampaign {
  campaignId: string
  campaignName?: string
  sponsorName?: string
  sponsorLogo?: string
  sponsorshipPercentage: number
  maxPerTransactionCents: number
  maxPerUserCents: number
  totalUsedCents: number
  remainingCents: number
  campaignEnd: string
  solverType: string
}

export interface SponsoredSpendStatus {
  eligible: boolean
  campaigns: SponsoredCampaign[]
}

interface SponsoredSpendResponse {
  data: SponsoredSpendStatus
}

export function useSponsoredSpendStatus() {
  const { address } = useAccount()
  const url = `${CARD_API_ENDPOINT}/v1/vendor/cards/sponsored-spend/status`
  const smartGet = createSmartGet(url)

  const { data, isLoading, error } = useQuery({
    queryKey: ['sponsored-spend-status', address],
    queryFn: () => smartGet() as Promise<SponsoredSpendResponse>,
    enabled: !!address,
    staleTime: 60_000, // 1 minute
    gcTime: 5 * 60_000,
  })

  const status = data?.data

  return {
    eligible: status?.eligible ?? false,
    campaigns: status?.campaigns ?? [],
    activeCampaign: status?.campaigns?.[0] ?? null,
    isLoading,
    error,
  }
}
